import { Injectable } from '@angular/core';
import { ApiHttpClient, ListOption } from '../modules/tcm-core.module';
import { BillingEntityInEntityOption, BillingEntityInEntitiesRequest, BillingEntityBaseViewModel } from '../models/billing-entities';

@Injectable({
  providedIn: 'root'
})
export class BillingEntityDataService {
  constructor(private readonly httpClient: ApiHttpClient) {
  }

  public getEntity(billingEntityId: number, cancellation: Promise<any>): Promise<BillingEntityBaseViewModel> {
    return this.httpClient.getJsonAsync<BillingEntityBaseViewModel>('billingEntities/getEntity', { billingEntityId }, cancellation);
  }

  public checkIdentifierExists(identifier: string, billingEntityId: number, cancellation: Promise<any>): Promise<boolean> {
    const request = { identifier: identifier, billingEntityId: billingEntityId };
    return this.httpClient.getJsonAsync<boolean>('billingEntities/checkIdentifierExists', request, cancellation, false);
  }

  public checkIsDefaultExists(billingEntityId: number, cancellation: Promise<any>): Promise<boolean> {
    const request = { billingEntityId: billingEntityId };
    return this.httpClient.getJsonAsync<boolean>('BillingEntities/CheckIsDefaultExists', request, cancellation, false);
  }

  public checkBillingEntityInClinicsExists(clinics: number[], billingEntityId: number, cancellation: Promise<any>): Promise<BillingEntityInEntityOption[]> {
    const request: BillingEntityInEntitiesRequest = { entities: clinics, billingEntityId: billingEntityId };
    return this.httpClient.postJsonAsync<BillingEntityInEntityOption[]>('BillingEntities/CheckBillingEntityInClinicsExists', request, cancellation);
  }

  public checkBillingEntityInDivisionsExists(divisions: number[], billingEntityId: number, cancellation: Promise<any>): Promise<BillingEntityInEntityOption[]> {
    const request: BillingEntityInEntitiesRequest = { entities: divisions, billingEntityId: billingEntityId };
    return this.httpClient.postJsonAsync<BillingEntityInEntityOption[]>('BillingEntities/CheckBillingEntityInDivisionsExists', request, cancellation);
  }

  public checkBillingEntityInInsuranceContractsExists(contracts: number[], billingEntityId: number, cancellation: Promise<any>): Promise<BillingEntityInEntityOption[]> {
    const request: BillingEntityInEntitiesRequest = { entities: contracts, billingEntityId: billingEntityId };
    return this.httpClient.postJsonAsync<BillingEntityInEntityOption[]>('BillingEntities/CheckBillingEntityInInsuranceContractsExists', request,  cancellation);
  }

  public checkBillingEntityInInsurancePlansExists(plans: number[], billingEntityId: number, cancellation: Promise<any>): Promise<BillingEntityInEntityOption[]> {
    const request: BillingEntityInEntitiesRequest = { entities: plans, billingEntityId: billingEntityId };
    return this.httpClient.postJsonAsync<BillingEntityInEntityOption[]>('BillingEntities/CheckBillingEntityInInsurancePlansExists', request,  cancellation);
  }
}
